import { isEmpty } from 'lodash'
import Vue from 'vue'
//
// User 정의 영역
//
// http get 처리용
const userParam = (context, params) => {
  return params
}

// http post 처리용
const userBody = (context, body) => {
  return body
}

// http request intercepter 처리용
const userRequestIntercepter = (request) => {
  // console.log('userRequestIntercepter::request', request, 'request.showSpinner', request.showSpinner)
  let promoStore = window.vue.getStore('promoInfo')
  let rootStore = window.vue.getStore('root')

  // console.log('request.showSpinner', request.showSpinner, Vue.prototype.$mmpLoading.isLoading())
  if (request.showSpinner === false) {
    if (Vue.prototype.$mmpLoading && Vue.prototype.$mmpLoading.isLoading()) { Vue.prototype.$mmpLoading.hide() }
  } else {
    if (Vue.prototype.$mmpLoading && !Vue.prototype.$mmpLoading.isLoading()) { Vue.prototype.$mmpLoading.show() }
  }

  let promoHeader = {
  }

  if (!isEmpty(rootStore.getters.getAppId)) {
    promoHeader['appId'] = rootStore.getters.getAppId
  }

  if (!isEmpty(promoStore.state.promoInfo.coGroupCode)) {
    promoHeader['MC-Co-Group'] = promoStore.state.promoInfo.coGroupCode
  }

  if (!isEmpty(promoStore.state.promoInfo.eduGroupCode)) {
    promoHeader['MC-Edu-Group'] = promoStore.state.promoInfo.eduGroupCode
  }

  request.headers = Object.assign({}, request.headers, promoHeader)

  return request
}

// http response intercepter 처리용
const userResponseIntercepter = (response) => {
  // console.log('userResponseIntercepter::response', response)
  if (Vue.prototype.$mmpLoading) {
    Vue.prototype.$mmpLoading.hide()
  }
  // console.log('>> userResponseIntercepter response', response)
  let interceptIgnore = false
  if (response.config && response.config.data) {
    // TODO : intercept를 방지하기 위한 코드(viewMyInfo로 로그인 정보를 조회할때 파라메터로 interceptIgnore가 들어갈경우, intercept 하지 않음)
    // console.log('>>typeof response.config.data  ', typeof response.config.data )
    if (typeof response.config.data === 'string') {
      const jsonData = JSON.parse(response.config.data)
      // console.log('>> userResponseIntercepter response.config.data', response.config.data)
      interceptIgnore = jsonData.interceptIgnore === 'TRUE'
    }
  }
  // console.log('>> userResponseIntercepter response interceptIgnore', interceptIgnore)
  if (response && response.data && response.data.status === 'ERROR' && response.data.code && !interceptIgnore) {
    switch (response.data.code) {
      case 'AUTHENTICATION_NOT_EXIST':
      case 'AUTHENTICATION_FAILED':
      case 'TOKEN_NOT_EXIST_IN_HEADER':
        /* 로그인 후 현재 페이지로 다시 돌아오기 위해 localStorage 에 저장. 2019.10.21 */
        localStorage.setItem('beforeRouterName', window.vue.getInstance('router').history.current.name)
        localStorage.setItem('beforeRouterParam', JSON.stringify(window.vue.getInstance('router').history.current.params))
        // window.vue.getInstance('router').replace({name: 'LoginError', params: {code: response.data.code}})//
        // TODO : LoginError를 가진 이름이 없어 여기를 올경우, 동작하지 않음
        break
      default:
        break
    }
  }

  return response
}

// http error intercepter 처리용
const userErrorIntercepter = (error) => {
  if (Vue.prototype.$mmpLoading) {
    Vue.prototype.$mmpLoading.hide()
  }
  if (error.message === 'Network Error' && window.vue.getStore('root').getters.getAppState === 'RUN') {
    window.vue.getInstance('router').push({'name': 'NetworkError'})
  }
  return error
}

export default {userParam, userBody, userRequestIntercepter, userResponseIntercepter, userErrorIntercepter}



// WEBPACK FOOTER //
// ./src/config/network/handler.js